import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { IVisitInfo } from '../models/IVisitInfo';


export function VisitReducer(state: IVisitInfo | null = null, action: AnyAction): IVisitInfo | null {
    switch (action.type) {
        case ActionTypes.SET_VISIT_INFO:
            return SetVisitInfo(state, action); 
        case ActionTypes.SET_FULL_CLIENT_STATE:
            return SetClientStateVisitInfo(state, action);
    }
    return state;
}

function SetVisitInfo(state: IVisitInfo | null, action: AnyAction): IVisitInfo {
    return action.payload as IVisitInfo;
}

function SetClientStateVisitInfo(state: IVisitInfo | null, action: AnyAction): IVisitInfo | null {
    if (action.payload.Visit) {
        let visitInfo = action.payload.Visit;
        visitInfo.StartTime = new Date(visitInfo.StartTime);
        return visitInfo as IVisitInfo;
    } else {
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/VisitReducer.tsx